define([ // eslint-disable-line import/no-amd
  'react',
  'underscore',
  'JSON',
  'immutable',
  'lib/sumome/sumolist/formsync',
  'es6!sumo/util',
  'es6!156085c5-0017-4150-b225-a731ad248f38/service/form',
  'es6!156085c5-0017-4150-b225-a731ad248f38/service/displayrules',
  'es6!launcher/util/listbuilder/wysiwyg/dom',
], (
  React, _, JSON, Immutable, FormSync, Util, ListBuilderForm,
  DisplayRules, WysiwygDom,
) => {
  class ListBuilderPopup extends ListBuilderForm {
    constructor(service, settings) {
      super(service, settings);

      this.isAnimating = false;
      this.isClickEmitted = false;
      this.isFormSubmitted = false;
      this.overlayTouchTarget = false;

      const popupJson = this.settings.get('json');

      // Get possible results and choose won at random
      const components = popupJson.getIn(['subscribe', 'components']);
      const gameComponent = components.find(component => component.get('type') === 'game');
      const gameOptions = gameComponent.get('options');
      const totalWeight = gameOptions.reduce((memo, val) => memo + val.get('weight'), 0);
      const randomWeight = Math.random() * totalWeight;
      let sum = 0;

      gameOptions.forEach((option, index) => {
        const weight = option.get('weight');
        sum += weight;

        if (sum >= randomWeight) {
          this.winningOption = option.set('index', index);
          return false;
        }

        return true;
      });

      this.winningOption = this.winningOption.merge({
        'resultText': gameComponent.get(this.winningOption.get('discountCampaignId') ? 'winText' : 'loseText'),
        'mediaSrc': `https:${Util.getMediaUrl(this.service.api, this.winningOption.get('contentMediaId'))}`,
      });

      this.receivePushApprovalResponse = this.receivePushApprovalResponse.bind(this);
    }

    showGameResults(done) {
      const { currentStep } = this;
      const step = this.getStep(currentStep);
      const contentDomEl = this.contentEl;
      if (!step || !contentDomEl) return;

      const formValues = Immutable.Map(_.mapObject(this.formValues, value => value.value));
      const formErrors = this.formErrors;

      step.render(contentDomEl, formValues, formErrors, {
        discountCode: this.discountCode,
        onFinishGameAnimation: done,
        winningOption: this.winningOption,
      });
    }
  }

  return ListBuilderPopup;
});
